<div fxShow.gt-sm fxHide.lt-md fxLayoutAlign="center center center" style="margin-top:120px;">
    <mat-card>
        <mat-card-title>
            <div fxLayout="row" class="pageTitle" fxLayoutAlign="start center">Ρόλοι και Δικαιώματα</div>
        </mat-card-title>
        <mat-card-content fxLayout="column">
            <div style="padding-left:5px; padding-right:5px;">

                <div fxLayout="row wrap" style="margin-top:15px;">
                    <h3>Ρόλοι</h3>
                    <div style="margin-right:100px;" fxLayoutAlign="center center center">

                        <table mat-table [dataSource]="roles" matSort
                               style="overflow-y: auto; margin-top:20px;">
                            <mat-card *ngIf="isRoleLoading" style="display: flex; justify-content: center; align-items: center"
                                      class="mat-elevation-z0">
                                <mat-progress-bar
                                        color="primary"
                                        mode="indeterminate">
                                </mat-progress-bar>
                            </mat-card>

                            <ng-container matColumnDef="role_name">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Ρόλος</th>
                                <td mat-cell *matCellDef="let role"> {{role.role_name}} </td>
                            </ng-container>

                            <ng-container matColumnDef="role_description">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header fxShow.gt-sm fxHide.lt-md>Περιγραφή</th>
                                <td mat-cell *matCellDef="let role" fxShow.gt-sm fxHide.lt-md> {{role.role_description}} </td>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Ενέργειες</th>
                                <td mat-cell *matCellDef="let role">
                                    <div fxLayout="row wrap" fxLayoutAlign="center center">
                                        <!--                <button mat-icon-button matTooltip="Διαχείριση Δικαιωμάτων Ενεργειών"-->
                                        <!--                        (click)="managementDialog(role, 0)">-->
                                        <!--                  <mat-icon>build</mat-icon>-->
                                        <!--                </button>-->
                                        <button mat-icon-button matTooltip="Διαχείριση Δικαιωμάτων Πλοήγησης"
                                                (click)="managementDialog(role, 1)">
                                            <mat-icon>public</mat-icon>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="rolesColumnsToDisplay; sticky: true"></tr>
                            <tr mat-row *matRowDef="let record; columns: rolesColumnsToDisplay"></tr>
                        </table>

                    </div>
                </div>

            </div>
        </mat-card-content>

    </mat-card>
</div>

<div fxLayout="column" fxShow.lt-sm fxHide.gt-md style="margin-top:120px; padding-left: 5px; padding-right: 5px; margin-bottom: 20px;">
  <div fxLayout="row" class="pageTitle" fxLayoutAlign="start center">Ρόλοι και Δικαιώματα</div>

  <div style="margin-top:10px; margin-bottom:10px;">
    <h3>Ρόλοι</h3>
  </div>

  <div  *ngFor="let role of roles.data" fxLayout="row" fxLayoutAlign="center center">
    <mat-card style="margin-top:5px;" fxFlex="grow">
      <mat-card-content style="font-family: 'Century Gothic', sans-serif !important;">
        <div fxLayout="column" fxLayoutGap="5px">
          <div fxLayout="row">
            <strong style="width:20%;">Ρόλος:</strong><span style="width:80%; text-align: center;"> {{role.role_name}}</span>
          </div>

          <div fxLayout="row">
            <strong style="width:30%;">Περιγραφή:</strong> <span style="width:70%;text-align: left; justify-content: center">{{role.role_description}}</span>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <mat-divider></mat-divider>
        <div fxLayout="row wrap" fxLayoutAlign="center center">
<!--          <button mat-icon-button matTooltip="Διαχείριση Δικαιωμάτων Ενεργειών"-->
<!--                  (click)="managementDialog(role, 0)">-->
<!--            <mat-icon>build</mat-icon>-->
<!--          </button>-->
          <button mat-icon-button matTooltip="Διαχείριση Δικαιωμάτων Πλοήγησης"
                  (click)="managementDialog(role, 1)">
            <mat-icon>public</mat-icon>
          </button>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>

</div>

